import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setIesList: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.loading = !!payload.loading;
};

// 新增或编辑弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.data = payload.data;
  state.dialog.title = payload.title;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
